import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoaderService } from '../../../core/services/loader.service';
import { PaymentRequest } from '../../../types/payment/payment-request';
import { PaymentProcessingStatus } from '../../../types/payment/payment-processing-status';

@Component({
  selector: 'app-payment-processed',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './payment-processed.component.html',
  styleUrl: './payment-processed.component.less'
})
export class PaymentProcessedComponent implements OnInit {
  @Input() request!: PaymentRequest;
  public paymentStatus: string = 'not_set';
  statusImageSrc: string = '';
  statusDescription: string = '';
  showPayAgainButton: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private loader: LoaderService
  ) {}

  ngOnInit(): void {
    this.paymentStatus = this.route.snapshot.paramMap.get('paymentStatus')!;

    switch (this.paymentStatus) {
      case PaymentProcessingStatus.paid:
        this.statusImageSrc = 'assets/images/checkmark.svg';
        this.statusDescription = 'Je betaling is gelukt!';
        break;
      case PaymentProcessingStatus.pending:
        this.statusImageSrc = 'assets/images/cross.svg';
        this.statusDescription = 'Je betaling is afwachting!';
        break;
      case PaymentProcessingStatus.expired:
        this.statusImageSrc = 'assets/images/cross.svg';
        this.statusDescription = 'Je betaling is expired!';
        this.showPayAgainButton = true;
        break;
      case PaymentProcessingStatus.cancelled:
        this.statusImageSrc = 'assets/images/cross.svg';
        this.statusDescription = 'Je hebt de betaling afgebroken.';
        this.showPayAgainButton = true;
        break;
      default:
        this.statusImageSrc = 'assets/images/cross.svg';
        this.statusDescription = 'De betaling is mislukt.';
        this.showPayAgainButton = true;
    }
    setTimeout(() => {
      this.loader.hideLoader();
      sessionStorage.clear();
    }, 200);
  }
}
